/**
 * Euro-Eingabe und Cent-Speicherung.
 *
 * Gespeichert wird in Cent als Ganzzahl — Fließkomma-Euro würde beim
 * Bruttolistenpreis früher oder später einen Cent verlieren, und der Wert geht
 * in die Bewertung des geldwerten Vorteils ein.
 *
 * Die Eingabe folgt deutscher Schreibweise: Punkt als Tausender-, Komma als
 * Dezimaltrennzeichen. Die englische Form wird trotzdem angenommen, weil sie
 * beim Einfügen aus einer Tabelle regelmäßig auftaucht.
 */
export function parseEuroToCent(input: string): number | undefined {
  const trimmed = input.trim();
  if (trimmed === '') return undefined;

  const normalized = trimmed
    .replace(/[€\s]/g, '')
    // Kommas sind hier immer Dezimaltrennzeichen; Punkte nur dann, wenn kein
    // Komma vorkommt und die Gruppierung nicht zu ihnen passt.
    .replace(/\.(?=\d{3}(\D|$))/g, '')
    .replace(',', '.');

  const value = Number(normalized);
  // NaN wird bewusst durchgereicht: Zod erzeugt daraus eine Meldung am Feld.
  // Eine stille 0 wäre schlimmer — sie sähe aus wie eine gültige Angabe.
  if (Number.isNaN(value)) return Number.NaN;

  return Math.round(value * 100);
}

export function formatCentAsEuro(cent: number | undefined): string {
  if (cent === undefined) return '';
  return (cent / 100).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
